import { DataService } from './dataService'
export const TntService = {
	

	getTntfreight: async (data) => {
		return DataService.get('/admin/get_tnt_land_freight', data)
	},

	importTntfreightData: async (data) => {
		return DataService.post('/admin/import_tnt_land_freight', data)
	},

	exportTntfreightData: async (data) => {
		return DataService.get('/admin/export_tnt_land_freight', data)
	},

}

export default TntService;